import React from 'react';
import {
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    CardActions,
    Button,
    Chip,
    Box
} from '@mui/material';
import { GitHub, Launch } from '@mui/icons-material';
import { projects } from '../data/projectsData';

export const Projects: React.FC = () => {
    return (
        <Container component="main" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h2" component="h1" gutterBottom>
                Projects
            </Typography>
            <Grid container spacing={3}>
                {projects.map((project, index) => (
                    <Grid item xs={12} md={6} key={index}>
                        <Card>
                            <CardContent>
                                <Typography variant="h5" component="h2" gutterBottom>
                                    {project.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" paragraph>
                                    {project.description}
                                </Typography>
                                <Box sx={{ mb: 2 }}>
                                    {project?.technologies?.map((tech) => (
                                        <Chip
                                            key={tech}
                                            label={tech}
                                            size="small"
                                            sx={{ mr: 1, mb: 1 }}
                                        />
                                    ))}
                                </Box>
                            </CardContent>
                            <CardActions>
                                {project.githubUrl && (
                                    <Button
                                        startIcon={<GitHub />}
                                        href={project.githubUrl}
                                        target="_blank"
                                        size="small"
                                    >
                                        Code
                                    </Button>
                                )}
                                {project.liveUrl && (
                                    <Button
                                        startIcon={<Launch />}
                                        href={project.liveUrl}
                                        target="_blank"
                                        size="small"
                                    >
                                        Live Demo
                                    </Button>
                                )}
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}; 